import React from 'react';
import { Provider } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import { Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import DateFnsUtils from '@date-io/date-fns';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';

import AppProvider from './hooks';
import Routes from './routes';
import history from './services/history';
import store from './store';
import GlobalStyle from './styles/global';
import muiStyles from './styles/material';

const theme = createMuiTheme(muiStyles);

const App: React.FC = () => (
  <Provider store={store}>
    <Router history={history}>
      <MuiThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <AppProvider>
            <Routes />
          </AppProvider>

          <>
            <ReduxToastr
              timeOut={3000}
              newestOnTop
              preventDuplicates
              position="top-right"
              transitionIn="fadeIn"
              transitionOut="fadeOut"
              progressBar
              closeOnToastrClick
              confirmOptions={{
                okText: 'Sim',
                cancelText: 'Não',
              }}
            />
            <ToastContainer autoClose={3000} />
            <GlobalStyle />
          </>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    </Router>
  </Provider>
);

export default App;
